import { trackLinkClick } from "@/utils/adobeAnalytics";
import Image from "../Image";
import Link from "../Link";
import CardCategory from "./CardCategory";

interface CardProps {
  imageSrc: string;
  title: string;
  body: string;
  categories: { title: string; text: string }[];
  topPicks?: boolean;
  button: {
    text: string;
    type: "primary" | "secondary" | "tertiary" | "quaternary";
    url: string;
    size?: "sm" | "md" | "lg";
  };
}

const Card = ({
  imageSrc,
  title,
  body,
  categories,
  topPicks,
  button,
}: CardProps) => (
  <div
    className={`lc-flex lc-flex-col lc-flex-1 lc-overflow-hidden lc-p-4 lc-text-white ${
      topPicks ? "lc-bg-cfa-blue-975" : ""
    }`}
  >
    <Image imageSrc={imageSrc} alt={title} topPicks={topPicks} />

    <div className="lc-flex lc-flex-col lc-flex-1 lc-mt-2.5 lc-font-normal">
      <div className="lg:lc-min-h-[240px]">
        <h3 className="lc-text-1xl lc-mb-2.5 lc-font-semibold">{title}</h3>
        <p className="lc-mb-4">{body}</p>
      </div>
    </div>
    <div className="lc-flex lc-flex-col lc-flex-1 lc-mt-2.5">
      {categories.map((category, index) => (
        <CardCategory key={index} title={category.title} text={category.text} />
      ))}
      <Link
        text={button.text}
        type={button.type}
        onClick={() => trackLinkClick(button.text, button.url)}
        size={button.size}
        href={button.url}
        target="_self"
      />
    </div>
  </div>
);

export default Card;
